/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
// TEMPORARY WE WILL REMOVE THIS.
import React from 'react';
import * as vds from '@vds/typography';
import {
  Modal as VDSModal,
  ModalTitle as VDSModalTitle,
  ModalBody as VDSModalModalBody,
  ModalFooter as VDSModalFooter,
} from '@vds/modals';
import styled from 'styled-components';

const ExtraLargeTitle = styled.span`
font-size: 2.75rem;
font-weight: 750;
line-height: 2.6125rem;
`;
const ExtraExtraLargeTitle = styled.span`
font-size: 4rem;
font-weight: 750;
line-height: 3.8rem;
`;

export const Modal = (props) => (<div id={props.id}><VDSModal tabIndex={null} {...props} /></div>);
export const ModalTitle = (props) => (<VDSModalTitle tabIndex={null} {...props} />);
export const ModalBody = (props) => (<VDSModalModalBody tabIndex={null} {...props} />);
export const ModalFooter = (props) => (<VDSModalFooter tabIndex={null} {...props} />);

export class Title extends React.PureComponent {
  render() {
    const { children, size, ...rest } = this.props;
    if (size === 'extraLarge') {
      return (
        <vds.Title size="large" {...rest}>
          <ExtraLargeTitle>
            {children}
          </ExtraLargeTitle>
        </vds.Title>
      );
    }

    if (size === 'extraExtraLarge') {
      return (
        <vds.Title size="large" {...rest}>
          <ExtraExtraLargeTitle>
            {children}
          </ExtraExtraLargeTitle>
        </vds.Title>
      );
    }

    return (<vds.Title {...this.props} />);
  }
}

export class Body extends React.PureComponent {
  render() {
    return (<vds.Body {...this.props} />);
  }
}
export class Micro extends React.PureComponent {
  render() {
    return (<vds.Micro {...this.props} />);
  }
}
